import i18n from "../../../../../../constants/i18n";
import ET3Div from "../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import Et3Text from "../../../../../../core/et3-text";
import Et3Margin from "../../../../../../core/et3-ui/ET3Margin";
import getKhattabatStore from "../../../../../../stores/khattabat-stores";

const OneOTwoMessagesCounters = withLiteObserverAndTheme<{
  clientConversationID: string;
  oneOTwoConversationId: string;
}>((props) => {
  const { theme, clientConversationID, oneOTwoConversationId } = props;
  const { colors } = theme;
  const {
    khattabaMessagesCounter,
    clientMessagesCounter,
    matchMessagesCounter
  } = getKhattabatStore().get102ConversationsMessagesCounters({
    clientConversationID,
    oneOTwoConversationId
  });

  return (
    <ET3Div
      width={0}
      height={45}
      alignItems={"center"}
      fDirection={"row"}
      style={{ width: "auto" }}
      color={""}
      justifyContent={"flex-end"}
      withShadow={false}
      isExtendable={false}
      isScrollable={false}
      onClick={() => {}}
    >
      <Et3Text
        fontFamily={"MEDIUM"}
        fontSize={24}
        isSpan={false}
        text={i18n.getWithExtraData(
          i18n.get("KHATTABA_102_COUNTER"),
          `${khattabaMessagesCounter}`
        )}
        style={{}}
        color={colors.all.black}
      />
      <Et3Margin top={0} bottom={0} left={5} right={5} />
      <Et3Text
        fontFamily={"MEDIUM"}
        fontSize={24}
        isSpan={false}
        text={i18n.getWithExtraData(
          i18n.get("CLIENT_102_COUNTER"),
          `${clientMessagesCounter}`
        )}
        style={{}}
        color={colors.all.black}
      />
      <Et3Margin top={0} bottom={0} left={5} right={5} />
      <Et3Text
        fontFamily={"MEDIUM"}
        fontSize={24}
        isSpan={false}
        text={i18n.getWithExtraData(
          i18n.get("MATCH_102_COUNTER"),
          `${matchMessagesCounter}`
        )}
        style={{}}
        color={colors.all.black}
      />
    </ET3Div>
  );
});

export default OneOTwoMessagesCounters;
